export const DIRECTIVE_NAME = FixedMatrixHeader.DIRECTIVE_NAME = 'ktFixedMatrixHeader';
export default function FixedMatrixHeader() {
    return {
        restrict: 'A',
        controller: FixedMatrixHeaderController,
        link: ($scope, $elem, $attrs, $ctrl) => {
            $ctrl.elem = $elem;
            $ctrl.$onInit();
        },
    };
}

export function FixedMatrixHeaderController($window) {
    'ngInject';

    const vm = this;
    const RESERVED_OFFSET_TOP = 190;
    const headerSelector = '.compare-offers-company';
    const header = document.querySelector(`${headerSelector}`);
    const headerTopOffset = header.getBoundingClientRect().top;

    const headerClassNameSelectors = `${headerSelector} .item-name`;
    const headerButtonsSelectors = `${headerSelector} button`;
    const headerItemCompanySelector = `${headerSelector} .item-company`;
    const headerItemAddressSelector = `${headerSelector} .item-address`;

    let stickyElements;

    setTimeout(() => {
        stickyElements = document.querySelectorAll(`${headerButtonsSelectors}, ${headerClassNameSelectors}, ${headerItemAddressSelector}, ${headerItemCompanySelector}`);
    }, 1000);

    let lastKnownScrollPosition = 0;
    let ticking = false;

    Object.assign(vm, {
        $onInit,
    });

    function doSomething(scrollPos) {
        if (scrollPos > headerTopOffset) {
            [].forEach.call(stickyElements, function(item) {
                const res = scrollPos - RESERVED_OFFSET_TOP;
                item.style.top = `${res}px`;
            });
        } else {
            [].forEach.call(stickyElements, function(item) {
                item.style.top = '0px';
            });
        }
    }

    function $onInit() {
        subscribe();
    }

    function subscribe() {
        $window.addEventListener('scroll', function() {
            lastKnownScrollPosition = $window.scrollY;

            if (!ticking) {
                $window.requestAnimationFrame(function() {
                    doSomething(lastKnownScrollPosition);
                    ticking = false;
                });
                ticking = true;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/cars/directives/fixed-matrix-header/fixed-matrix-header-component.js